import S3Repository from 'repositories/S3Repository'

import { getLineBearerToken } from './bearerToken'
import { isAuthenticatedS3URL } from './s3Authenticated'
import { isPdfUrl } from './utils'

/** Abre PDF/imagem do bucket privado num novo separador (com Bearer quando há sessão). */
export async function openAuthenticatedS3InNewTab (url: string): Promise<void> {
  if (!isAuthenticatedS3URL(url) || !getLineBearerToken()) {
    window.open(url, '_blank', 'noopener,noreferrer')
    return
  }

  const blob = await S3Repository.getImage(url)
  const pdfFix =
    blob.type === 'application/octet-stream' && isPdfUrl(url)
      ? new Blob([blob], { type: 'application/pdf' })
      : blob

  const objUrl = URL.createObjectURL(pdfFix)
  window.open(objUrl, '_blank', 'noopener,noreferrer')
}
